import { Copy20Regular, Copy24Regular } from "@fluentui/react-icons";
import { useState } from "react";

export default function CopyButton(props: { CopyValue: string }) {
  const [CopySuccess, SetCopySuccess] = useState(false);

  return (
    <div
      className={"CopyIcon" + (CopySuccess ? " Success" : "")}
      onClick={() => {
        if (CopySuccess) {
          SetCopySuccess(false);
        } else {
          // console.log(props.CopyValue);
          navigator.clipboard.writeText(props.CopyValue);
          SetCopySuccess(true);
        }
      }}
    >
      <Copy20Regular />
    </div>
  );
}
